module.exports = __webpack_public_path__ + "static/media/kcb_logo.ffec02b5.png";